var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.message.text &&
    (_vm.message.type === "human" || _vm.message.type === "feedback")
      ? _c(
          "div",
          {
            staticClass: "message-text",
            style: {
              color: _vm.message.type === "bot" ? "" : "#fff",
              padding: this.message.alts !== null ? "1em " : "",
              "font-size": "4vw",
              "padding-right": "0em"
            },
            attrs: { id: "map_container" }
          },
          [
            _c("span", { staticClass: "sr-only" }, [_vm._v("I say: ")]),
            _vm._v(_vm._s(_vm.message.text) + " ")
          ]
        )
      : _vm.altHtmlMessage && _vm.AllowSuperDangerousHTMLInMessage
      ? _c("div", {
          directives: [
            { name: "scroll", rawName: "v-scroll" },
            {
              name: "lazy",
              rawName: "v-lazy",
              value: { selector: "img" },
              expression: "{ selector: 'img' }"
            }
          ],
          ref: "messageT",
          staticClass: "message-text",
          style: {
            padding: "0.5em",
            "margin-left": _vm.message.responseCard ? "-10vw" : "",
            width: _vm.message.responseCard ? "105vw" : "",
            fontSize: _vm.message.responseCard ? "4.5vw" : "",
            "font-weight": !_vm.message.responseCard
              ? ""
              : this.$i18n.locale === "tc" || "zh" || "ja"
              ? "900"
              : ""
          },
          domProps: { innerHTML: _vm._s(_vm.altHtmlMessage) }
        })
      : _vm.message.text && _vm.shouldRenderAsHtml
      ? _c(
          "div",
          [
            _c("div", {
              staticClass: "message-text",
              style: {
                marginTop: _vm.message.id === 2 ? "-18vw" : "",
                display:
                  _vm.message.text === "Sorry" ||
                  _vm.message.text === "Aww" ||
                  _vm.message.text === "啊哇" ||
                  this.message.text === "ああ" ||
                  this.message.text === "噢"
                    ? "none"
                    : "",

                fontSize: _vm.message.responseCard ? "" : "",

                "padding-right": "0.5em"
              },
              attrs: { "d-flex": "" },
              domProps: { innerHTML: _vm._s(_vm.botMessageAsHtml) }
            }),
            _vm.message.id === 2
              ? _c(
                  "swiper",
                  {
                    ref: "mySwiper",
                    staticClass: "my-swipe2",
                    attrs: { options: _vm.swiperOption }
                  },
                  [
                    _c("swiper-slide", { staticClass: "my-swipe3" }, [
                      _vm.message.id === 2
                        ? _c(
                            "div",
                            _vm._l(_vm.initalMsg, function(item, index) {
                              return _c(
                                "ul",
                                {
                                  key: index,
                                  staticClass: "initalMsgbtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.Faq(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "li",
                                    {
                                      style: {
                                        "font-size": "6vw",
                                        marginLeft: "8vw",
                                        color: "#55bee5"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "question" }, [
                                        _vm._v(" " + _vm._s(item) + " ")
                                      ])
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]),
                    _c(
                      "swiper-slide",
                      { staticClass: "my-swipe4" },
                      _vm._l(_vm.initalMsg2, function(item, index) {
                        return _c(
                          "ul",
                          {
                            key: index,
                            staticClass: "initalMsgbtn",
                            on: {
                              click: function($event) {
                                return _vm.Faq(item)
                              }
                            }
                          },
                          [
                            _c(
                              "li",
                              {
                                style: {
                                  "font-size": "6vw",
                                  marginLeft: "8vw",
                                  color: "#55bee5"
                                }
                              },
                              [
                                _c("div", { staticClass: "question" }, [
                                  _vm._v(" " + _vm._s(item) + " ")
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", {
                      staticClass: "swiper-pagination",
                      attrs: { slot: "pagination" },
                      slot: "pagination"
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.message.text.length > 110,
                    expression: "message.text.length > 110"
                  }
                ],
                on: { click: _vm.changeFoldState }
              },
              [
                _c(
                  "a",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "center",
                      color: "#0a79c3",
                      "font-size": "1rem"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.brandFold
                          ? _vm.$t("licence.Robot_massege_ViewMore")
                          : _vm.$t("licence.Robot_massege_ViewLess")
                      ) + " "
                    ),
                    _c("img", {
                      staticStyle: { margintop: "-0.8vw" },
                      style: {
                        transform: _vm.brandFold ? "rotate(-180deg)" : ""
                      },
                      attrs: {
                        src: require("../assets/up@2x.png"),
                        width: "22",
                        height: "22"
                      }
                    })
                  ]
                ),
                _c("div", { staticStyle: { width: "300px" } })
              ]
            )
          ],
          1
        )
      : _vm.message.text &&
        (_vm.message.type === "bot" || _vm.message.type === "agent")
      ? _c("div", { staticClass: "bot-message" }, [
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.message.type) + " says: ")
          ]),
          _vm._v(
            " " +
              _vm._s(
                _vm.shouldStripTags
                  ? _vm.stripTagsFromMessage(_vm.message.text)
                  : _vm.message.text
              ) +
              " "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }